import { formatCurrency } from '../../../../lib/CurrencyHelpers.js';
import { minutesToDuration } from '../../../../lib/DateTime.js';
import Stepper from '../../../Stepper.jsx';
import { CheckIcon } from '@heroicons/react/24/outline/index.js';
import React from 'react';
import { FormPart, FormStateName, part, state } from '~/lib/FormCssApi';
import { SelectionImage } from './SelectionBlock.jsx';

const SelectItemButton = ({
    children,
    image,
    rightContent,
    onClick,
    quantity,
    quantityIncrement,
    maxQuantity,
    onChangeQuantity,
    enableQuantity,
    isSelected,
    layout,
    className
}) => {
    return (
        <section
            type="button"
            {...part(FormPart.SELECTION_BLOCK)}
            {...state(isSelected && FormStateName.SELECTED)}
            onClick={() => {
                if (!isSelected || !enableQuantity) {
                    onClick();
                }
            }}
            className={`choose-block ${isSelected ? 'selected-block' : ''} ${layout === 'grid' ? '!items-stretch' : ''} ${className || ''}`}
        >
            <div
                className={layout === 'grid'
                    ? 'flex flex-col gap-2'
                    : 'flex flex-col gap-2 justify-between flex-1 @md:flex-row @md:gap-6 @md:items-center'
                }
            >
                {!!image && (
                    <SelectionImage image={image} className="shrink-0" />
                )}
                <div
                    className="flex flex-col flex-1 gap-1">
                        {children}
                </div>
                <div
                    className={layout === 'grid'
                        ? 'flex flex-col gap-2'
                        : 'flex flex-col gap-2 @md:flex-row @md:gap-4 @md:items-center'
                    }
                >
                    {!!rightContent && (
                        <div className="text-gray-500 text-sm flex">
                            {rightContent}
                        </div>
                    )}

                    {isSelected && enableQuantity && (
                        <Stepper
                            value={quantity}
                            onChange={onChangeQuantity}
                            maxValue={maxQuantity}
                            renderValue={v => {
                                return v * (quantityIncrement || 1);
                            }}
                        />
                    )}
                    {!(isSelected && enableQuantity) && (
                        <span
                            type="button"
                            {...part(FormPart.SELECTION_ACTION)}
                            {...state(isSelected && FormStateName.SELECTED)}
                            className="uppercase block bg-[#2C87F3] text-white py-2 px-4 rounded form-button btn-small text-sm text-center xs:w-fit"
                        >
                            {isSelected && (
                                <span className="flex justify-center items-center block">
                                    <CheckIcon className="w-5 h-5 mr-2" />
                                    Added
                                </span>
                            )}
                            {!isSelected && 'Add'}
                        </span>
                    )}
                </div>
            </div>
        </section>
    );
};

export default SelectItemButton;
